import React, { useState, useEffect } from 'react';
import { TListingGallery } from 'types/TListing';

type TUseCarousel = {
  imageUrls: TListingGallery['imageUrls'];
  imageSizes?: TListingGallery['media']['imageSizes'];
  toggleCarouselModal: (index: any) => void;
  title: string;
  alt: string;
  changeCarouselIndex: (index: any) => void;
};

type TCarouselProps = {
  index: number;
};

let ModalCarousel;
let GalleryCarousel;

const useCarousel = ({ imageUrls, imageSizes, toggleCarouselModal, alt, changeCarouselIndex }: TUseCarousel) => {
  const [showCarousel, setShowCarousel] = useState(false);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        const CarouselWrapper = (await import(/* webpackChunkName: "carousel" */ '../CarouselWrapper')).default;

        const carouselGallery = ({ index }) => (
          <CarouselWrapper
            onClickItemHandler={toggleCarouselModal}
            imageUrls={imageUrls}
            imageSizes={imageSizes}
            onChangeHandler={changeCarouselIndex}
            index={index}
            alt={alt}
          />
        );

        const carouselModal = ({ index }) => (
          <CarouselWrapper
            isModal={true}
            imageUrls={imageUrls}
            onChangeHandler={changeCarouselIndex}
            index={index}
            alt={alt}
          />
        );

        GalleryCarousel = ({ index }: TCarouselProps) => carouselGallery({ index });
        ModalCarousel = ({ index }: TCarouselProps) => carouselModal({ index });

        setShowCarousel(imageUrls.length > 1);
      } catch {}
    };

    loadComponent();
  }, [imageUrls.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    ModalCarousel,
    GalleryCarousel,
    showCarousel,
  };
};

export default useCarousel;
